export const SOURCE_TYPE = ['repository', 'integration', 'custom', 'ava'];
export const SEVERITY = ['critical', 'high', 'medium', 'low'];
export const STAGE = ['dev', 'test', 'staging', 'prod'];
